/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import CreateIntentTemplatesSideBarQuery from './__generated__/CreateIntentTemplatesSideBarQuery$parameters.ts';
import type { CreateIntentTemplatesSideBarQuery as QueryType } from './__generated__/CreateIntentTemplatesSideBarQuery.graphql.ts';

type Queries = { intentTemplateQueryReference: QueryType };

type EntryPointParams = {
	cloudId: string;
	key: string;
	isHideIntentDiscoveryWhenVaNotConfiguredEnabled: boolean;
};

type VirtualAgentCreateIntentTemplateSidebarEntryPointComponent = EntryPointComponent<
	Queries,
	{},
	{},
	{}
>;

export const virtualAgentCreateIntentTemplateSidebarEntryPoint: EntryPoint<
	VirtualAgentCreateIntentTemplateSidebarEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<VirtualAgentCreateIntentTemplateSidebarEntryPointComponent>(
		/* webpackChunkName: "async-virtual-agent-create-intent-templates-sidebar" */ './CreateIntentTemplatesSideBar.tsx',
	),
	getPreloadProps: ({
		cloudId,
		key,
		isHideIntentDiscoveryWhenVaNotConfiguredEnabled,
	}: EntryPointParams) => ({
		queries: {
			intentTemplateQueryReference: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters: CreateIntentTemplatesSideBarQuery,
				variables: {
					cloudId,
					key,
					isHideIntentDiscoveryWhenVaNotConfiguredEnabled,
				},
			},
		},
		entryPoints: {},
		extraProps: {},
	}),
});
